import { render, staticRenderFns } from "./SiteGip.vue?vue&type=template&id=7f5263d2&"
import script from "./SiteGip.vue?vue&type=script&lang=js&"
export * from "./SiteGip.vue?vue&type=script&lang=js&"
import style0 from "./SiteGip.vue?vue&type=style&index=0&id=7f5263d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports